"use client";
import { Address } from "@/dto/address";
import { Merchant } from "@/dto/merchant";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { setKey } from "react-geocode";
import { BusinessLocations } from "./businessLocations";
import { GoogleMap } from "./googleMap";
import { Links } from "./links";
import { OperatingHours } from "./operatingHours";

setKey(process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "");

export type ShowLinks = {
  returnsAndExchangePolicy: boolean;
  termsOfUsePolicy: boolean;
  shippingPolicy: boolean;
};

export interface MerchantFooterProps {
  merchant: Merchant;
  merchantName: string;
  merchantAddress: Address;
  merchantPhoneNumber: string;
  merchantEmail: string;
  facebookUrl?: string;
  instagramUrl?: string;
  businessHours: any;
  timezone: string;
  showLinks: ShowLinks;
  locale: string;
  isBusinessHourAvailable: boolean;
  isDuda?: boolean;
  bgColor?: string;
  textColor?: string;
  dynamicLinks?: any;
  merchantColor: string;
}

export const MerchantFooter = ({
  merchant,
  merchantName,
  merchantAddress,
  merchantPhoneNumber,
  merchantEmail,
  businessHours,
  facebookUrl,
  instagramUrl,
  timezone,
  showLinks,
  locale,
  isBusinessHourAvailable,
  isDuda = false,
  dynamicLinks = [],
  merchantColor,
}: MerchantFooterProps) => {
  return (
    <div
      data-testid={applyDataTestId(pom.merchantFooter.merchantFooter)}
      className={[
        "justify-between",
        "flex",
        "flex-wrap",
        "gap-12",
        "px-[60px]",
        "w-full",
        "items-start",
        "max-md:px-0",
        "max-md:flex-col",
        "py-[60px]",
      ].join(" ")}
    >
      <BusinessLocations
        {...{
          merchantName,
          merchantAddress,
          merchantPhoneNumber,
          merchantLocale: locale,
          merchantEmail,
          merchantColor,
          facebookUrl,
          instagramUrl,
          isDuda,
        }}
      />
      {!isDuda && (
        <div
          className={[
            "w-[280px]",
            "h-[280px]",
            "max-md:ml-0",
            "max-md:w-full",
          ].join(" ")}
        >
          <div
            className={["flex", "justify-center", "h-full", "w-full"].join(" ")}
          >
            <GoogleMap
              address={merchant.address}
              height={"280px"}
              width={"280px"}
            />
          </div>
        </div>
      )}
      <OperatingHours
        {...{ businessHours }}
        timezone={timezone}
        isBusinessHourAvailable={isBusinessHourAvailable}
      />
      <Links {...{ showLinks }} dynamicLinks={dynamicLinks} />
    </div>
  );
};

export function createAddressString({
  address1,
  address2,
  address3,
  city,
  state,
  zip,
  country,
}: Address) {
  return [address1, address2, address3, city, state, zip, country].join(", ");
}
